// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class SpecificItem {
  public value!: string;

  public isCorrect!: boolean;

  public static fromDto(dto: any): SpecificItem {
    const item: SpecificItem = new SpecificItem();
    item.value = dto.value;
    item.isCorrect = dto.isCorrect;
    return item;
  }
}
